import { Link } from 'react-router-dom'

export default function CompanyDashboard() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Company Dashboard</h1>
        <p className="text-gray-600">Manage your job postings and contracts</p>
      </div>

      {/* Quick stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Active Jobs</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">Currently posted</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Applications</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">Awaiting review</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Active Contracts</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">0</div>
          <div className="mt-1 text-sm text-gray-500">In progress</div>
        </div>
        <div className="card">
          <div className="text-sm font-medium text-gray-500">Total Spent</div>
          <div className="mt-1 text-3xl font-semibold text-gray-900">€0</div>
          <div className="mt-1 text-sm text-gray-500">This month</div>
        </div>
      </div>

      {/* CTA */}
      <div className="card mb-8 bg-gradient-to-r from-primary-50 to-accent-50">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Ready to hire?</h2>
            <p className="mt-1 text-gray-600">
              Post a job and connect with verified IT experts across Ireland.
            </p>
          </div>
          <Link to="/company/jobs/new" className="btn-primary">
            Post a Job
          </Link>
        </div>
      </div>

      {/* Quick actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-4">Quick Actions</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/company/jobs/new" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Post a new job
              </Link>
            </li>
            <li>
              <Link to="/experts" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                Search for experts
              </Link>
            </li>
            <li>
              <Link to="/company/candidates" className="flex items-center text-gray-600 hover:text-primary-600">
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Review candidates
              </Link>
            </li>
          </ul>
        </div>

        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-4">Recent Activity</h3>
          <div className="text-center py-8 text-gray-500">
            <p>No recent activity</p>
            <p className="text-sm mt-1">Applications and updates will appear here</p>
          </div>
        </div>
      </div>
    </div>
  )
}
